var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"el-icon-full-screen screenfull-svg",on:{"click":_vm.click}})])}
var staticRenderFns = []

export { render, staticRenderFns }